import { Navigate } from "react-router-dom";
import { routes } from "./constants";
import DashboardPage from "../pages/DashboardPage";
import TenantDetail from "../pages/tenant/TenantDetail";
import TenantList from "../pages/tenant/TenantList";
import SubscriptionBillingPage from "../pages/billing/SubscriptionBillingPage";
import AnalyticsReportsPage from "../pages/analytics/AnalyticsReportsPage";
import AdminControlsPage from "../pages/admin/AdminControlsPage";
import LoginPage from "../pages/LoginPage";
import AddTenant from "../pages/tenant/AddTenant";
import AddTenantSuccess from "../pages/tenant/AddTenantSuccess";
import PlanList from "../pages/billing/PlansList";
import EditTenant from "../pages/tenant/EditTenant";
import EditPlan from "../pages/billing/EditPlan";
import FreeTrailManagement from "../pages/billing/FreeTrailManagement";
import StaffList from "../pages/staff/StaffList";
import AddStaff from "../pages/staff/AddStaff";
import EditStaff from "../pages/staff/EditStaff";
import AddCoupons from "../pages/promotionCoupons/AddCoupons";
import EditCoupons from "../pages/promotionCoupons/EditCoupons";
import CouponList from "../pages/promotionCoupons/CouponList";
import Profile from "../pages/promotionCoupons/Profile";
import ViewStaff from "../pages/staff/ViewStaff";
import ViewTenant from "../pages/tenant/ViewTenant";
import AcmeCoOperation from "../pages/tenant/AcmeCoOperation";
import Reports from "../pages/reports";
import ProvisionTenants from "../pages/provisionTenants/index";
import DiscountManagement from "../pages/discountManagement/index";
import Setting from "../pages/setting";
import FeedbackTriage from "../pages/feedbackTriage/index";
import Security from "../pages/security/index";
import HelpPage from "../pages/help/HelpPage";
import ForgotPassword from "../pages/ForgotPassword";
import SetUpAuthentication from "../pages/auth/SetUpAuthentication";
import VarifyAuth from "../pages/auth/VarifyAuth";
import VerifyOtp from "../pages/auth/VerifyOtp";
import ResetPassword from "../pages/auth/ResetPassword";
import ImportCSV from "../pages/discountManagement/ImportCSV";

export const authRoutes = [
  { path: routes.homePage, element: <Navigate to={routes.login} /> },
  { path: routes.login, element: <LoginPage /> },
  { path: routes.forgotPassword, element: <ForgotPassword /> },
  { path: routes.verifyOtp, element: <VerifyOtp /> },
  { path: routes.resetPassword, element: <ResetPassword /> },
  { path: routes.verifyauth, element: <VarifyAuth /> },
  { path: routes.setUpAuth, element: <SetUpAuthentication /> },
];

export const mainRoutes = [
  { path: routes.homePage, element: <Navigate to={routes.dashboard} /> },
  { path: routes.dashboard, element: <DashboardPage /> },
  { path: routes.profile, element: <Profile /> },
  { path: routes.tenants, element: <TenantList /> },
  { path: routes.staff, element: <StaffList /> },
  { path: routes.addStaff, element: <AddStaff /> },
  { path: routes.editStaff, element: <EditStaff /> },
  { path: routes.viewStaff, element: <ViewStaff /> },
  { path: routes.promotionCoupons, element: <CouponList /> },
  { path: routes.addcoupons, element: <AddCoupons /> },
  { path: routes.editcoupons, element: <EditCoupons /> },
  { path: routes.plan, element: <PlanList /> },
  { path: routes.freeTrialManagement, element: <FreeTrailManagement /> },
  { path: routes.editPlan, element: <EditPlan /> },
  { path: routes.addTenants, element: <AddTenant /> },
  { path: routes.editTenants, element: <EditTenant /> },
  { path: routes.viewTenants, element: <ViewTenant /> },
  { path: routes.acmeCoOperation, element: <AcmeCoOperation /> },
  { path: routes.tenantDetails, element: <TenantDetail /> },
  { path: routes.tenantAddedSuccess, element: <AddTenantSuccess /> },
  {
    path: routes.subscriptionBillingPage,
    element: <SubscriptionBillingPage />,
  },
  { path: routes.analyticsReport, element: <AnalyticsReportsPage /> },
  { path: routes.adminControls, element: <AdminControlsPage /> },
  { path: routes.provisionTenants, element: <ProvisionTenants /> },
  { path: routes.editProvisionTenants, element: <ProvisionTenants /> },
  { path: routes.reports, element: <Reports /> },
  { path: routes.setting, element: <Setting /> },
  { path: routes.discountManagement, element: <DiscountManagement /> },
  { path: routes.importCsv, element: <ImportCSV /> },
  { path: routes.feedbackTriage, element: <FeedbackTriage /> },
  { path: routes.security, element: <Security /> },
  { path: routes.help, element: <HelpPage /> },
];

export const otherRoutes = [
  { path: routes.login, element: <LoginPage /> },
  { path: "*", element: <LoginPage /> },
];
